var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"white-button",attrs:{"href":_vm.link}},[(_vm.leftIcon)?_c('i',{staticClass:"mr-2",class:`${_vm.leftIcon}`}):_vm._e(),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e(),(_vm.icon)?_c('i',{class:`${_vm.icon}`}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }